import { render } from "./TheHeader.vue?vue&type=template&id=4bde3e50&scoped=true"
import script from "./TheHeader.vue?vue&type=script&lang=ts"
export * from "./TheHeader.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-4bde3e50"

export default script